function UnsavedChangesDialog({ open, onStay, onDiscard }) {
  if (!open) return null;

  return (
    <div
      className="edit-unsaved-dialog"
      role="dialog"
      aria-modal="true"
      aria-labelledby="edit-unsaved-dialog-title"
      aria-describedby="edit-unsaved-dialog-desc"
      data-testid="edit-unsaved-dialog"
    >
      <div className="edit-unsaved-dialog__backdrop" />
      <div className="edit-unsaved-dialog__panel">
        <h2 id="edit-unsaved-dialog-title" className="edit-unsaved-dialog__title">
          Незбережені зміни
        </h2>
        <p id="edit-unsaved-dialog-desc" className="edit-unsaved-dialog__body">
          У формі є незбережені зміни. Якщо вийти зараз, їх буде втрачено.
        </p>
        <div className="edit-unsaved-dialog__actions">
          <button
            type="button"
            className="action-btn"
            onClick={onStay}
            data-testid="edit-unsaved-stay"
          >
            Залишитися
          </button>
          <button
            type="button"
            className="action-btn action-btn--danger"
            onClick={onDiscard}
            data-testid="edit-unsaved-discard"
          >
            Відкинути зміни і вийти
          </button>
        </div>
      </div>
    </div>
  );
}

export default UnsavedChangesDialog;
